type BrowserInfo = {
  browser: string;
  os: string;
};

export function parseUserAgent(userAgent: string): BrowserInfo {
  let browser = "Desconhecido";
  let os = "Desconhecido";

  // Detecta o Sistema Operacional
  if (/Windows NT 10.0/.test(userAgent)) os = "Windows 10";
  else if (/Windows NT 6.3/.test(userAgent)) os = "Windows 8.1";
  else if (/Windows NT 6.2/.test(userAgent)) os = "Windows 8";
  else if (/Windows NT 6.1/.test(userAgent)) os = "Windows 7";
  else if (/Mac OS X (\d+[_\.]\d+)/.test(userAgent)) {
    const match = userAgent.match(/Mac OS X (\d+[_\.]\d+)/);
    os = match ? `macOS ${match[1].replace("_", ".")}` : "macOS";
  } else if (/Linux/.test(userAgent)) os = "Linux";
  else if (/Android/.test(userAgent)) os = "Android";
  else if (/iPhone|iPad|iPod/.test(userAgent)) os = "iOS";

  // Detecta o navegador
  if (/Chrome\/([0-9.]+)/.test(userAgent) && !/Edg\/|OPR\//.test(userAgent)) {
    const match = userAgent.match(/Chrome\/([0-9.]+)/);
    browser = match ? `Chrome ${match[1]}` : "Chrome";
  } else if (/Firefox\/([0-9.]+)/.test(userAgent)) {
    const match = userAgent.match(/Firefox\/([0-9.]+)/);
    browser = match ? `Firefox ${match[1]}` : "Firefox";
  } else if (/Safari\/([0-9.]+)/.test(userAgent) && !/Chrome/.test(userAgent)) {
    const match = userAgent.match(/Version\/([0-9.]+)/);
    browser = match ? `Safari ${match[1]}` : "Safari";
  } else if (/Edg\/([0-9.]+)/.test(userAgent)) {
    const match = userAgent.match(/Edg\/([0-9.]+)/);
    browser = match ? `Edge ${match[1]}` : "Edge";
  } else if (/OPR\/([0-9.]+)/.test(userAgent)) {
    const match = userAgent.match(/OPR\/([0-9.]+)/);
    browser = match ? `Opera ${match[1]}` : "Opera";
  }

  return { browser, os };
}
